<template>
  <div class="install-guide">
    <!-- 主内容区 -->
    <div class="container">
      <div class="logo-box">
        <img class="logo" :src="require('@/assets/logo.png')" alt="App Logo">
      </div>
      <div class="app-name">51ucard</div>
    </div>

    <!-- 第一步：安装TestFlight -->
    <div class="step-box step1">
      <div class="step-tag">{{$t('u_card_00860')}}</div>
      <div class="step-title">{{$t('u_card_00861')}}</div>
      <div class="step-desc">{{$t('u_card_00862')}}</div>
      <a href="https://apps.apple.com/app/testflight/id899247664" class="install-btn" target="_blank">
        <span class="btn-icon testflight-icon"></span>
        {{$t('u_card_00863')}}
      </a>
    </div>

    <!-- 第二步：安装App -->
    <div class="step-box step2">
      <div class="step-tag">{{$t('u_card_00864')}}</div>
      <div class="step-title">{{$t('u_card_00865')}}</div>
      <div class="step-desc">{{$t('u_card_00866')}}</div>
      <a href="https://testflight.apple.com/join/SqNZNfF6" class="install-btn" target="_blank">
        <span class="btn-icon app-icon"></span>
        {{$t('u_card_00867')}}
      </a>
      <div class="note">{{$t('u_card_00868')}}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 可以在这里添加需要的数据
    }
  }
}
</script>

<style scoped lang="scss">
* { 
  margin: 0; 
  padding: 0; 
  box-sizing: border-box; 
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif; 
} 

.install-guide {
  min-height: 100vh;
  background-color: #3b82f6; 
}

.header { 
  background-color: #fff; 
  padding: 15px 10px; 
  display: flex; 
  justify-content: space-between; 
  align-items: center; 
  border-bottom: 1px solid #eee; 
} 

.header .close { 
  color: #333; 
  font-size: 16px; 
} 

.header .url { 
  color: #666; 
  font-size: 14px; 
} 

.header .tools { 
  display: flex; 
  gap: 15px; 
} 

.header .tools span { 
  color: #666; 
  font-size: 16px; 
} 

.container { 
  background-color: #3b82f6; 
  padding: 20px 15px; 
  text-align: center; 
} 

.logo-box { 
  width: 80px; 
  height: 80px; 
  background-color: #fff; 
  border-radius: 12px; 
  display: flex; 
  justify-content: center; 
  align-items: center; 
  margin: 0 auto 10px; 
} 

.logo-box .logo { 
  width: 60px; 
  height: 60px; 
  border-radius: 8px;
} 

.app-name { 
  color: #fff; 
  font-size: 24px; 
  font-weight: 600; 
} 

.step-box { 
  background-color: #fff; 
  border-radius: 12px; 
  margin: 15px; 
  padding: 20px 15px; 
  position: relative; 
} 

.step-tag { 
  position: absolute; 
  top: -12px; 
  left: 0; 
  background-color: #9333ea; 
  color: #fff; 
  font-size: 14px; 
  padding: 4px 12px; 
  border-radius: 20px; 
} 

.step-title { 
  font-size: 18px; 
  font-weight: 600; 
  margin-bottom: 10px; 
  color: #333; 
} 

.step-desc { 
  font-size: 14px; 
  color: #666; 
  margin-bottom: 20px; 
  line-height: 1.5; 
} 

.install-btn { 
  display: flex; 
  justify-content: center; 
  align-items: center; 
  gap: 8px; 
  width: 100%; 
  padding: 12px 0; 
  background-color: #fff; 
  border: 1px solid #ccc; 
  border-radius: 8px; 
  font-size: 16px; 
  color: #333; 
  cursor: pointer; 
  text-decoration: none;
} 

.install-btn .btn-icon { 
  width: 24px; 
  height: 24px; 
} 

.testflight-icon {
  background: url("https://developer.apple.com/assets/elements/icons/testflight/testflight-64x64_2x.png") center/contain no-repeat;
}

.app-icon {
  background: url("@/assets/logo.png") center/contain no-repeat;
}

.note { 
  color: #ef4444; 
  font-size: 12px; 
  margin-top: 10px; 
  text-align: center; 
}
</style>